<template>
    <div
        class="bax-form-group"
        v-bind:class="error != '' ? 'bax-input-error' : ''"
    >
        <label>{{ label }}</label>
        <input
            class="bax-input-control"
            type="text"
            :value="value"
            :placeholder="placeholder"
            :max="max"
            v-on:input="updateValue($event.target.value)"
        />
        <p>{{ error }}</p>
    </div>
</template>

<script>
export default {
    name: 'VueInput',
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
        max: {},
    },
    methods: {
        updateValue(value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style scoped>
</style>
